/**
 * <ym-sale-ends data-end="1793491200" data-date="Oct 31" [data-countdown]>…</ym-sale-ends>
 * Keeps "Sale ends" in step with the real end time (data-end, Unix seconds): "Sale ends Oct 31"
 * until the last 72 hours, then "Sale ends in {d}d {h}h" (rounded down), updated every minute.
 * Hidden once the sale is over. The time comes from the product, so it never resets per visitor
 * or page load. The server renders the first state; this corrects it for cached pages.
 * data-lead / data-lead-countdown replace "Sale ends" / "Sale ends in" (the sticky bar uses
 * "ends" / "ends in").
 */
(function () {
  if (customElements.get('ym-sale-ends')) return;

  const HOUR = 3600 * 1000;
  const DAY = 24 * HOUR;

  class YmSaleEnds extends HTMLElement {
    connectedCallback() {
      this.end = parseInt(this.dataset.end || '', 10) * 1000;
      if (!this.end) return;
      this.update();
      this.timer = window.setInterval(() => this.update(), 60 * 1000);
    }

    disconnectedCallback() {
      window.clearInterval(this.timer);
    }

    update() {
      const left = this.end - Date.now();
      if (left <= 0) {
        this.hidden = true;
        window.clearInterval(this.timer);
        return;
      }
      const countdown = left <= 72 * HOUR;
      this.toggleAttribute('data-countdown', countdown);
      const lead = this.querySelector('[data-ym-ends-lead]');
      const value = this.querySelector('[data-ym-ends-value]');
      if (lead) {
        lead.textContent = countdown
          ? this.dataset.leadCountdown || 'Sale ends in'
          : this.dataset.lead || 'Sale ends';
      }
      if (value) {
        value.textContent = countdown
          ? `${Math.floor(left / DAY)}d ${Math.floor((left % DAY) / HOUR)}h`
          : this.dataset.date || '';
      }
    }
  }

  customElements.define('ym-sale-ends', YmSaleEnds);
})();
